import { ApolloLink, Observable } from "@apollo/client";
import { getMainDefinition } from "@apollo/client/utilities";

/**
 * Counts mutations still awaiting a response, across every client on the
 * page, so a reload onto a new build (see `startVersionWatch`) never cuts one
 * off mid-flight.
 */
let pending = 0;

export const hasPendingMutations = (): boolean => pending > 0;

export const pendingMutationsLink = new ApolloLink((operation, forward) => {
  const def = getMainDefinition(operation.query);
  if (def.kind !== "OperationDefinition" || def.operation !== "mutation") {
    return forward(operation);
  }
  return new Observable((observer) => {
    pending += 1;
    let settled = false;
    const settle = () => {
      if (settled) return;
      settled = true;
      pending -= 1;
    };
    const sub = forward(operation).subscribe({
      next: (value) => observer.next(value),
      error: (err) => {
        settle();
        observer.error(err);
      },
      complete: () => {
        settle();
        observer.complete();
      },
    });
    return () => {
      settle();
      sub.unsubscribe();
    };
  });
});
